import { FC, useReducer } from "react";
import styles from "./registration.module.scss";
import { PAGES } from "./RegistrationDetails/actions";
import { AlreadyRegistered } from "./RegistrationDetails/AlreadyRegistered";
import { CreatePassword } from "./RegistrationDetails/CreatePassword";
import {
  initialRegistrationDetailsState,
  registrationDetailsReducer,
} from "./RegistrationDetails/registrationDetailsReducer";
import { YourDetails } from "./RegistrationDetails/YourDetails";

interface Props {
  setScreen: () => void;
  params: {
    name: string;
    email: string;
    password: string;
    steps: [1, 2, 3];
    currentStep: number;
    closeFunction: () => void;
  };
}

export const RegistrationDetails: FC<Props> = ({ setScreen, params }) => {
  const [state, dispatch] = useReducer(
    registrationDetailsReducer,
    initialRegistrationDetailsState,
  );

  const { name, email, errorMsg, currentScreen } = state;
  const { steps, currentStep } = params;

  return (
    <div className={`${styles.wrapper} ${styles.registrationDetails}`}>
      <div className={styles.panel}>
        <section>
          {currentScreen === PAGES.DETAILS && (
            <YourDetails
              steps={steps}
              currentStep={currentStep}
              errorMsg={errorMsg}
              dispatch={dispatch}
              setScreen={setScreen}
              userDetails={{
                name,
                email,
              }}
            />
          )}
          {currentScreen === PAGES.PASSWORD && (
            <CreatePassword
              steps={steps}
              currentStep={currentStep}
              dispatch={dispatch}
              setScreen={setScreen}
              params={params}
              userDetails={{
                name,
                email,
              }}
            />
          )}
          {currentScreen === PAGES.ALREADY_REGISTERED && (
            <AlreadyRegistered {...{ email, steps, currentStep, setScreen }} />
          )}
        </section>
      </div>
    </div>
  );
};
